import type { SentryInstance } from 'shared';
import { useFirebaseStore } from '../firebase-store';
import { freedomApp } from '../../../entities';
import { cacheConfig } from '../../../features';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const withFirebase = (sentryModel: SentryInstance) => {
  const firebaseStore = useFirebaseStore();

  firebaseStore
    .init(firebaseConfig)
    .then(() => {
      sessionStorage.setItem(
        'cacheStatus',
        cacheConfig.CACHE_NOT_CLEARED_MESSAGE,
      );
      const remoteVersion = firebaseStore.serializedRemoteConfig?.app_version;
      const localVersion = import.meta.env.VITE_APP_VERSION;

      if (remoteVersion !== localVersion) {
        //only for stage and testing
        sessionStorage.setItem(
          'cacheStatus',
          cacheConfig.CACHE_CLEARED_MESSAGE_VERSIONS,
        );
        freedomApp.lib.clearCache();
      }
    })
    .catch(err => {
      sessionStorage.setItem(
        'cacheStatus',
        cacheConfig.CACHE_CLEARED_MESSAGE_ERROR + err,
      );
      freedomApp.lib.clearCache();
      sentryModel.captureException(
        sentryModel.getReadableError(
          sentryModel.createCustomErrorText(
            sentryModel.errorPrefix.DEFAULT,
            'INIT_FIREBASE',
          ),
          err,
        ),
      );
    });
};
